import { render } from "./AboutCapacity.vue?vue&type=template&id=7d3c0032"
import script from "./AboutCapacity.vue?vue&type=script&lang=js"
export * from "./AboutCapacity.vue?vue&type=script&lang=js"

import exportComponent from "/home/test/Documents/GitHub/LpMooveTrainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__